import styled from '@emotion/styled';

import { useAppSelector } from '../../../../shared/store';

import {
  buildSupportedDeliveryInfo,
} from '../../shared/utils/deliveryTextBuilder';

import { AcceptedProduct } from '../../types';

import MainImage from '../components/ATF/MainImage';
import Name from '../components/ATF/Name';
import Price from '../components/ATF/Price';
import SalesGuide from '../components/ATF/SalesGuide';
import ProductCouponBanner from '../../shared/coupon/ProductCouponBanner';
import InfoList from '../components/ATF/info-list/InfoList';
import BuySection from '../components/ATF/buy-section/BuySection';
import Loading from '../../../../shared/components/Loading/Loading';

const Container = styled.article`
  display: flex;
  justify-content: space-between;
  font-family: 'Noto Sans';
`;

const ATFInfoWrapper = styled.div`
  width: 560px;
`;

interface Props {
  product: AcceptedProduct;
}

export default function ATFContainer({ product }: Props) {
  const { isGuest } = useAppSelector(({ auth }) => auth);
  const { loading, couponBanner } = useAppSelector(({ productDetail }) => productDetail);

  const {
    no, mainImageUrl, name, shortDescription, sellerName, legacyPromotion,
    discountRate, discountedPrice, basePrice, retailPrice, memberCoupon,
    isExpectedPoint, expectedPointRatio, expectedPoint, isMultiplePrice,
    notSalesText, afterSaleServiceInfo, salesUnit, volume, deliveryTypeNames,
    productOrigin, todayBrix, soldOutText, storageTypes, allergy, expirationDate,
    extraInfos, guides,
  } = product;

  const loggedIn = !isGuest;

  const deliveryInfo = buildSupportedDeliveryInfo(deliveryTypeNames);

  return (
    <Container id="product-atf">
      {loading && <Loading />}
      <MainImage mainImageUrl={mainImageUrl} />
      <ATFInfoWrapper>
        <Name
          productNo={no}
          deliveryInfo={deliveryInfo}
          name={name}
          shortDescription={shortDescription}
        />
        <Price
          discountRate={discountRate}
          discountedPrice={discountedPrice}
          basePrice={basePrice}
          retailPrice={retailPrice}
          isMultiplePrice={isMultiplePrice}
          legacyPromotion={legacyPromotion}
          memberCoupon={memberCoupon}
        />
        <SalesGuide
          loggedIn={loggedIn}
          isExpectedPoint={isExpectedPoint}
          expectedPointRatio={expectedPointRatio}
          expectedPoint={expectedPoint}
          isDiscountProduct={!!discountedPrice}
        />
        {couponBanner &&
          <ProductCouponBanner
            type={couponBanner.type}
            bannerName={couponBanner.bannerName}
            bannerLink={couponBanner.bannerLink}
            couponAccessKey={couponBanner.accessKey}
            extraInfo={couponBanner.extraInfo}
          />
        }
        <InfoList
          deliveryInfo={deliveryInfo}
          salesUnit={salesUnit}
          volume={volume}
          todayBrix={todayBrix}
          sellerName={sellerName}
          productOrigin={productOrigin}
          storageTypes={storageTypes}
          allergy={allergy}
          expirationDate={expirationDate}
          soldOutText={soldOutText}
          extraInfos={extraInfos}
          guides={guides}
          notSalesText={notSalesText}
          afterSaleServiceInfo={afterSaleServiceInfo}
        />
        <BuySection loggedIn={loggedIn} />
      </ATFInfoWrapper>
    </Container>
  );
}
